import { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'

import { App } from './App'
import codeplatformJson from './codeplatform.json'
import { FirebaseConfig, FirebaseProvider } from './context'
// import { useVersionController } from "./hooks";
import { Config, getLanguageFromStorage, getThemeFromStorage, languageKey, READY, themeKey } from './utils'

const inIframe = window.location !== window.parent.location
const senderOrigin = inIframe && document.referrer.slice(0, -1)
const waitForMessage =
  senderOrigin &&
  (senderOrigin.startsWith('http://localhost') ||
    senderOrigin.endsWith('codeplatform.com') ||
    senderOrigin.startsWith('https://backoffice.invisiblecfo.com'))

export const AppWrapper = () => {
  const [wait, setWait] = useState(waitForMessage)
  const [inDevice, setInDevice] = useState(false)
  const [webFirebaseConfig, setWebFirebaseConfig] = useState<FirebaseConfig>()
  const [version, setVersion] = useState<string>()
  const [firestorePrefix, setFirestorePrefix] = useState<string>()
  const [config, setConfig] = useState(codeplatformJson as Config)
  const [language, setLanguage] = useState(getLanguageFromStorage())
  const [theme, setTheme] = useState(getThemeFromStorage())
  const [email, setEmail] = useState<string>()
  const [token, setToken] = useState<string>()
  // useVersionController();

  const [desktopMode, setDesktopMode] = useState(window.innerWidth >= 680)
  const [wideDesktopMode, setWideDesktopMode] = useState(window.innerWidth >= 1032)

  useEffect(() => {
    localStorage.setItem(languageKey, language)
  }, [language])

  useEffect(() => {
    localStorage.setItem(themeKey, theme)
  }, [theme])

  useEffect(() => {
    if (wait) {
      const onMessage = ({ data }: any) => {
        if (data && typeof data === 'object') {
          const { inDevice, webFirebaseConfig, version, firestorePrefix, config, language, theme, email, token } = data
          if (inDevice !== undefined && webFirebaseConfig && version && config && language && theme) {
            setInDevice(inDevice)
            setWebFirebaseConfig(webFirebaseConfig)
            setVersion(version)
            setFirestorePrefix(firestorePrefix)
            setConfig(config)
            setLanguage(language)
            setTheme(theme)
            setEmail(email)
            setToken(token)
            setWait(false)
          } else if (inDevice !== undefined) {
            setInDevice(inDevice)
            setWait(false)
          }
        }
      }
      window.addEventListener('message', onMessage)
      window.parent.postMessage(READY, '*')
      return () => {
        window.removeEventListener('message', onMessage)
      }
    }
  }, [])

  useEffect(() => {
    const resize = () => {
      setDesktopMode(window.innerWidth >= 680)
      setWideDesktopMode(window.innerWidth >= 1032)
    }
    window.addEventListener('resize', resize)
    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  return wait ? (
    <></>
  ) : (
    <>
      <ToastContainer theme={theme} />
      <FirebaseProvider
        webFirebaseConfig={webFirebaseConfig}
        version={version}
        firestorePrefix={firestorePrefix}
        inDevice={inDevice}
        language={language}
        theme={theme}
        setTheme={setTheme}
        desktopMode={desktopMode}
        config={config}
      >
        <App
          inDevice={inDevice}
          language={language}
          setLanguage={setLanguage}
          theme={theme}
          setTheme={setTheme}
          desktopMode={desktopMode}
          wideDesktopMode={wideDesktopMode}
          config={config}
          email={email}
          token={token}
        />
      </FirebaseProvider>
    </>
  )
}
